import React, { FC, useContext } from 'react';
import styled from 'styled-components';
import { Text } from 'src/components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { CmsContext } from 'logic/context/cms';
import { ContentWrapper } from 'components/content-wrapper/ContentWrapper';
import { colors } from 'src/styles/colors';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const TextWrapper = styled.div<{ mobile: boolean }>`
  max-width: ${({ mobile }) => (mobile ? '850px' : '100%')};
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const TitleSection: FC = () => {
  const { minTablet } = useBreakpoints();
  const cms = useContext(CmsContext);
  const { firstTitle, firstSubTitle } = cms;

  return (
    <ContentWrapper
      backgroundColor={colors.primary}
      padding={minTablet ? '150px 0' : '90px 0 65px 0'}
    >
      <Content>
        <TextWrapper mobile={minTablet}>
          <Text
            color="white"
            fontWeight={700}
            size={minTablet ? 48 : 26}
            style={{ marginBottom: minTablet ? 15 : 18 }}
          >
            {firstTitle}
          </Text>
          <Text color="white" size={minTablet ? 16 : 14}>
            {firstSubTitle}
          </Text>
        </TextWrapper>
      </Content>
    </ContentWrapper>
  );
};
